import(/* webpackMode: "eager" */ "/app/src/app/forum/[boardSlug]/error.tsx");
